// extracted by mini-css-extract-plugin
export default {"container":"styles_container__ZQQpl","textWrapper":"styles_textWrapper__GZF7X","link":"styles_link__LEcY2"};